// components/Layout.jsx
import React, { useState, useEffect, useRef } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import PdfViewerModal from './modals/PdfViewerModal';
import './css/Layout.css';
import './css/Toolbar.css';
import { isTokenValid, logoutAndRedirect } from '../utils/auth';

const FOOTER_BUFFER = 8;

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    if (window.innerWidth < 992) return false;
    const stored = localStorage.getItem('sidebarOpen');
    return stored === 'true';
  });
  const [isMobile, setIsMobile] = useState(false);
  const sidebarRef = useRef(null);
  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(38);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!isTokenValid(token)) {
      logoutAndRedirect();
      return;
    }

    const onStorage = (e) => {
      if (e.key === 'token') {
        const t = e.newValue;
        if (!isTokenValid(t)) logoutAndRedirect();
      }
    };
    window.addEventListener('storage', onStorage);
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  useEffect(() => {
    const updateFooterHeight = () => {
      const h = footerRef.current ? footerRef.current.offsetHeight : 38;
      setFooterHeight(h);
    };
    updateFooterHeight();
    let ro;
    if (typeof ResizeObserver !== 'undefined' && footerRef.current) {
      ro = new ResizeObserver(entries => {
        for (let entry of entries) {
          const h = entry.contentRect ? Math.ceil(entry.contentRect.height) : (footerRef.current ? footerRef.current.offsetHeight : 38);
          setFooterHeight(h);
        }
      });
      ro.observe(footerRef.current);
    } else {
      window.addEventListener('resize', updateFooterHeight);
    }
    return () => { if (ro && ro.disconnect) ro.disconnect(); else window.removeEventListener('resize', updateFooterHeight); };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      localStorage.setItem('sidebarOpen', !prev);
      return !prev;
    });
  };

  return (
    <div
      className="layout-container"
      style={{ 
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} sidebarRef={sidebarRef} />

      <div
        className="full-screen-div"
        style={{
          backgroundImage: `url('/assets/desktop.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: '44px',
          paddingBottom: `${footerHeight + FOOTER_BUFFER}px`,
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          marginLeft: isMobile ? '0px' : (isSidebarOpen ? '200px' : '40px'),
          transition: 'margin-left 0.3s ease-in-out',
          minHeight: 0,
        }}
      >
        <div
          className="content-container"
          style={{
            flex: '1 1 auto',
            paddingTop: '10px',
            paddingLeft: (!isMobile && isSidebarOpen) ? '30px' : '10px',
            paddingRight: '10px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            minHeight: 0,
            transition: 'padding-left 0.3s ease-in-out',
          }}
        >
          {children}
        </div>
        <div ref={footerRef}>
          <Footer />
        </div>
      </div>
      <PdfViewerModal />
    </div>
  );
};

export default Layout;
